<template>
        <modal v-if="task" name="task" @before-close="closeTask"
               :adaptive="true"
               :max-width="1000"
               width="80%"
               height="auto"
        >
            <div class="add-card-details">
            <div class="setting-profile-wrapper">
                <div class="card-details-wrapper">
                    <div class="card-details">
                        <div class="card-details-heading">
                            <div class="card-details-to-do"
                                 @focusout="hideMoveCard($event)"
                                 tabindex="0"
                                >
                                <img src="/assets/img/planner-icon.svg" alt=""> In <a
                                    class="todo-movecard pointer"
                                    @click="showMoveCard()">{{  task.column.name }}</a>
                                <div class="to-do-movecard"
                                     v-if="showMoveForm && taskPositions"  >
                                    <h4>Move Card</h4>
                                    <div class="movecard-form">
                                        <div class="form-row">
                                            <div class="form-group col-sm-8">
                                                <label>Column</label>
                                                <select class="form-control"
                                                        @change="selectColumn($event)">

                                                    <option
                                                        v-for="column in taskPositions"
                                                        :selected="task.column.position == column.id"
                                                        :value="column.id"
                                                    >{{ column.name }}
                                                        <span v-if="task.column.position == column.id">(current)</span>
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group col-sm-4"
                                                 v-if="selectedMoveColumn">
                                                <label>Position</label>
                                                <select class="form-control" v-model="selectedMovePosition">
                                                    <option
                                                        v-for="n in selectedMoveColumn.length + 1"
                                                    >{{ n }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <button @click="moveTask()"
                                                class="btn btn-primary"
                                                :disabled="!selectedMoveColumn"
                                        >{{ moveBtnTx }}</button>
                                    </div>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="title-input text-word-break task-title-input"
                                :value="task.name"
                                @keyup.enter="$event.target.blur()"
                                @blur="updateTaskProperty($event, 'name')"
                            >
<!--                            <div class="community-details-textarea">-->
<!--                                <div class="textarea-btn">-->
<!--                                    <a href="javascript:;" class="tox-mbtn"><svg id="Capa_1" enable-background="new 0 0 467.765 467.765" height="14" width="14" viewBox="0 0 467.765 467.765" xmlns="http://www.w3.org/2000/svg"><path fill="#A2A2A2" d="m58.471 0v87.706h58.471v-29.235h87.706v350.824h-58.471v58.471h175.412v-58.471h-58.471v-350.824h87.706v29.235h58.471v-87.706z"></path></svg></a>-->
<!--                                    <div class="textarea-bar">-->
<!--                                        <ul>-->
<!--                                            <li class="edit-menu"><a href="javascript:;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil-alt" height="22" width="22" class="svg-inline&#45;&#45;fa fa-pencil-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#fff" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path></svg></a></li>-->
<!--                                            <li class="text-menu"><a href="javascript:;"><svg id="Capa_1" enable-background="new 0 0 467.765 467.765" height="20" width="20" viewBox="0 0 467.765 467.765" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" d="m58.471 0v87.706h58.471v-29.235h87.706v350.824h-58.471v58.471h175.412v-58.471h-58.471v-350.824h87.706v29.235h58.471v-87.706z"></path></svg></a></li>-->
<!--                                            <li><a href="javascript:;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks" height="22" width="22" class="svg-inline&#45;&#45;fa fa-tasks fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#979797" d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg></a></li>-->
<!--                                            <li><a href="javascript:;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="list-ol" height="22" width="22" class="svg-inline&#45;&#45;fa fa-list-ol fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#979797" d="M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"></path></svg></a></li>-->
<!--                                            <li><a href="javascript:;"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="list-ul" height="22" width="22" class="svg-inline&#45;&#45;fa fa-list-ul fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#979797" d="M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg></a></li>-->
<!--                                            <li class="close-menu"><a href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g><g><path fill="#979797" d="M15.668.332a1.135 1.135 0 0 1 0 1.606L9.605 8l6.063 6.062a1.135 1.135 0 1 1-1.606 1.606L8 9.605l-6.062 6.063a1.135 1.135 0 1 1-1.606-1.606L6.395 8 .332 1.938A1.135 1.135 0 1 1 1.938.332L8 6.395 14.062.332a1.135 1.135 0 0 1 1.606 0z"></path></g></g></svg></a></li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="community-details-textarea">
                                <ckeditor :editor="editor"
                                          v-model="task.description"
                                          :config="editorConfig"
                                          @blur="updateTaskDesc()"
                                          @keyup.enter="$event.target.blur()"
                                ></ckeditor>
                            </div>
                        </div>
                        <TaskComments />

                    </div>
                    <div class="card-details-right" id="card-right-bar" :style="{ backgroundColor: convertHex(task.colour_label, 40) || '#ffffff'}">
                        <div class="text-right pointer">
                            <a title="Close (Esc)" @click="closeTask">
                                <img src="/assets/img/close-icon.svg"/>
                            </a>
                        </div>

                        <div class="right-details-colums" v-if="task_user.name">
                            <h4>CREATED BY</h4>
                            <div class="profile-author">
                                <div class="user-img">
                                    <avatar v-bind:username="task_user.name"  v-bind:src="'/storage/' + task_user.photo" v-if="task_user.name" :size="45"></avatar>
                                </div>
                                <div class="profile-author-name">
                                    <h3>{{  task_user.name }}</h3>
                                    <span class="date">{{ created_at | moment("D MMMM YYYY") }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="right-details-colums">
                            <h4>COLOUR</h4>
                            <div class="choose-colour-list">
                                <div class="custom-control custom-radio custom-control-inline"
                                     v-for="(colourChoice, $index) in colour_label_choices">
                                    <input type="radio" :id="'customRadioInline' + $index" name="customRadioInline1"
                                           :checked="task.colour_label == colourChoice || (!task.colour_label && $index === 0)"
                                           :value="colourChoice"
                                           class="custom-control-input"
                                           @change="setColourLabel($event, colourChoice)"
                                    >
                                    <label class="custom-control-label"
                                           :for="'customRadioInline' + $index"
                                           :style="[ ( task.colour_label == '#FFFFFF' || !task.colour_label ) && $index === 0 ? { backgroundColor: colourChoice, borderColor: 'lightgray' } : { backgroundColor: colourChoice } ]"
                                    ></label>
                                </div>
                            </div>
                        </div>
                        <div class="right-details-colums">
                            <h4>ACTIONS</h4>
                            <div class="dax-edited-btn" v-if="!delConfirm">
                                <a href="javascript:;" @click="delConfirm = true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18"
                                         viewBox="0 0 15 18">
                                        <g>
                                            <g>
                                                <path
                                                    d="M9.75 7.5v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0zM6 6.75a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 6 6.75zm6.662-2.25H2.338l1.259 11.332a.75.75 0 0 0 .745.668h6.316a.75.75 0 0 0 .745-.667zM14.25 3a.75.75 0 0 1 0 1.5h-.079l-1.278 11.498A2.249 2.249 0 0 1 10.657 18H4.344a2.25 2.25 0 0 1-2.237-2.002L.829 4.5H.75a.75.75 0 0 1 0-1.5H4.5v-.75A2.25 2.25 0 0 1 6.75 0h1.5a2.25 2.25 0 0 1 2.25 2.25V3zm-7.5-1.5a.75.75 0 0 0-.75.75V3h3v-.75a.75.75 0 0 0-.75-.75z"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </a>
<!--                                <a href="javascript:;">-->
<!--                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"-->
<!--                                         viewBox="-1 -2 20 19">-->
<!--                                        <g>-->
<!--                                            <g>-->
<!--                                                <g>-->
<!--                                                    <path fill="#FF3B30"-->
<!--                                                          d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"></path>-->
<!--                                                </g>-->
<!--                                            </g>-->
<!--                                        </g>-->
<!--                                    </svg>-->
<!--                                </a>-->
<!--                                <a href="javascript:;">-->
<!--                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">-->
<!--                                        <g>-->
<!--                                            <g>-->
<!--                                                <path-->
<!--                                                    d="M6.23 14.308a2.538 2.538 0 0 1-2.538-2.539V5.077H2.407c-.565 0-1.022.457-1.022 1.022v8.44c0 1.147.93 2.076 2.077 2.076h8.44c.564 0 1.021-.457 1.021-1.022v-1.285zM6.23 0h9.232A2.538 2.538 0 0 1 18 2.538v9.231a2.538 2.538 0 0 1-2.538 2.539h-1.154v1.285A2.407 2.407 0 0 1 11.9 18h-8.44A3.462 3.462 0 0 1 0 14.538v-8.44a2.407 2.407 0 0 1 2.407-2.406h1.285V2.538A2.538 2.538 0 0 1 6.231 0zm0 1.385c-.636 0-1.153.516-1.153 1.153v9.231c0 .637.517 1.154 1.154 1.154h9.23c.638 0 1.154-.517 1.154-1.154V2.54c0-.638-.516-1.154-1.153-1.154z"></path>-->
<!--                                            </g>-->
<!--                                        </g>-->
<!--                                    </svg>-->
<!--                                </a>-->
                            </div>
                            <div v-else>
                                <!--                                <p>Are you sure you want to delete?</p>-->
                                <a href="javascript:;" @click="delConfirm = false">Cancel &nbsp;</a>
                                <a href="javascript:;" @click="removeTask($event)" class="btn btn-danger"
                                   style="border-radius: 5px;">
                                    Confirm
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </modal>
    <!-- //end of popup -->
</template>

<script>
import {mapGetters} from 'vuex';
import {VueFinalModal} from 'vue-final-modal/lib';
import vmodal from 'vue-js-modal'

import CKEditor from '@ckeditor/ckeditor5-vue'
import TaskComments from "./TaskComments";
import defaultBoard from "../../store/modules/default-board";
import Avatar from 'vue-avatar';
import Vue from "vue";
import ClickOutside from 'vue-click-outside'


export default {
    components: {
        VueFinalModal,
        ckeditor: CKEditor.component,
        TaskComments,
        Avatar,
        vmodal
    },
    data: () => {
        return {
            showModal: true,
            checklist: [],
            colour_label: '#FFFFFF',
            colour_label_choices: [
                '#FFFFFF',
                '#FFAF88',
                '#FF8888',
                '#347EBF',
                '#23A6CD',
                '#FFE188',
                '#73D364',
                '#9E6CFF'
            ],
            delConfirm: false,


            //
            showMoveForm: false,
            selectedMoveColumn: [],
            selectedMovePosition: null,
            moveBtnTx: 'Move',

            editor: BalloonBlockEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'bold',
                        'numberedList',
                        'bulletedList',
                        'todoList',
                    ]
                },
                language: 'en',
                blockToolbar: [
                    'numberedList',
                    'bulletedList',
                    'todoList',
                ],
                licenseKey: 'en',
            }
        };
    },
    mounted() {
        if (this.task) {
            this.colour_label = this.task.colour_label;
        }
        this.popupItem = this.$el

        setTimeout(() => {
            this.$modal.show('task');
        }, 500);


    },
    watch: {
        // when user clicked on an task
        $route(to, from) {
            this.showModal = true;
        },
        showModal(to, from) {
            if (from === true && to === false) {
                this.closeTask();
            }
        }
    },
    computed: {
        ...mapGetters(['getTask', 'getTaskPositions', 'getUser', 'getDate']),

        task() {
            return this.getTask(this.$route.params.id);
        },
        taskPositions() {
            return this.getTaskPositions();
        },
        task_user() {
            return this.getUser();
        },
        created_at() {
            return this.getDate();
        }

    },
    methods: {
        updateTaskProperty(e, key) {
            this.$store.commit('UPDATE_TASK', {
                task: this.task,
                key,
                value: e.target.value
            })
        },
        showMoveCard() {
            this.showMoveForm = !this.showMoveForm;
            // sets task positions in column on open move
            this.selectedMoveColumn = this.taskPositions[this.task.column.position - 1] ?? [];
        },
        hideMoveCard(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.showMoveForm = false;
            }
        },
        closePopup(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.closeTask();
            }
        },
        updateTaskDesc() {
            this.$store.commit('UPDATE_TASK', {
                task: this.task,
                key: 'description',
                value: this.task.description
            })
        },

        removeTask(e) {
            this.$store.commit('REMOVE_TASK', {
                task_id: this.task.id,
            })
            this.closeTask();
        },

        setColourLabel(e, color) {
            if(!color) {
                return;
            }
            this.updateTaskProperty(e, 'colour_label');

            document.getElementById('task-badge-' + this.$route.params.id)
                .style.backgroundColor = this.convertHex(color, 40);

            document.getElementById('card-right-bar')
                .style.backgroundColor = this.convertHex(color, 40);

            let borderColor = '';
            if(color == '#FFFFFF') {
                borderColor = 'lightgray';
            }

            let labels = document.querySelectorAll(`label[for=customRadioInline0]`);
            for (let i = 0; i < labels.length; i++) {
                labels[i].style.borderColor = borderColor;
            }


        },

        convertHex(hexCode,opacity){
            if(! hexCode) {
                return null;
            }
            let hex = hexCode.replace('#','');

            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }

            let r = parseInt(hex.substring(0,2), 16),
                g = parseInt(hex.substring(2,4), 16),
                b = parseInt(hex.substring(4,6), 16);

            return 'rgba('+r+','+g+','+b+','+opacity/100+')';
        },

        updateDesc() {
            let key = 'description';
            this.$store.commit('UPDATE_TASK', {
                task: this.task,
                key,
                value: this.task.description
            })
        },
        closeTaskOnFocusOut(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                this.closeTask();
            }
        },

        closeTask() {
            if(this.$route.name == 'Pipeline Planner Task') {
                this.$router.push({'name': 'Data Pipeline Planner', params: {'doc_id': this.$route.params.doc_id}});
            } else if(this.$route.name == 'Model Planner Task') {
                this.$router.push({'name': 'Data Model Planner', params : { 'doc_id' : this.$route.params.doc_id} });
            } else {
                this.$router.push({'name': 'Analytics Planner', params : { 'doc_id' : this.$route.params.doc_id} });
            }
        },

        selectColumn(e) {
            let colPos = e.target.value;
            this.selectedMoveColumn = this.taskPositions[colPos - 1] ?? [];
            if(this.selectedMoveColumn.length == 0) {
                this.selectedMovePosition = 1;
            } else {
                this.selectedMovePosition = null;
            }
        },

        moveTask() {

            this.moveBtnTx = 'Moving...'

            this.board = JSON.parse(localStorage.getItem('board')) || defaultBoard;

            // let fromTaskIndex = this.task.position - 1 ?? 0;
            this.columnIndex = this.task.column.position - 1 ?? 0;
            this.column = this.board[this.columnIndex];



            this.column = this.board.columns[this.columnIndex]
            this.taskIndex = this.selectedMovePosition - 1 ?? 0;

            let fromColumnIndex = this.task.column.position - 1 ?? 0;
            let toColumnIndex = this.selectedMoveColumn.id - 1 ?? 0;

            setTimeout(() => {
                this.$store.commit('MOVE_POPUP_TASK', {
                    fromColumnIndex: fromColumnIndex,
                    fromTaskIndex: this.task.position - 1 ?? 0,
                    toColumnIndex: toColumnIndex,
                    toTaskIndex: this.selectedMovePosition - 1 ?? 0
                })
                this.moveBtnTx = 'Move';
                setTimeout(() => {
                    this.showMoveForm = false;
                }, 800);
            }, 1500)


        }
    },
    directives: {
        ClickOutside
    }
}
</script>

<style>
.ck-content {
    min-height: 200px;
    max-height: 400px;
    border: none;
    margin-bottom: 50px;
}

.vfm--fixed, .ck-block-toolbar-button {
    z-index: 999 !important;
}

input.title-input {
    font-size: 25px;
    margin-bottom: 12px;
    border: none;
    font-family: 'Fira Sans', sans-serif;
    font-weight: bold;
}

.ck-content ul, .ck-content ol {
    margin-left: 30px;
}

.ck-focused {
    overflow: auto;
    padding: 0 var(--ck-spacing-standard);
    border: none;
    box-shadow: none;
}

.vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}

@media (max-width: 425px) {
    .vm--modal {
        width: 85% !important;
    }
}

.add-card-details {
    padding: 0px !important;
}

.setting-profile-wrapper {
    margin: auto !important;
}

.card-details-right, .setting-profile-wrapper {
    box-shadow: none !important;
}

.ck-content .todo-list .todo-list__label>input {
    top:-2px;
}

.ck-content .todo-list span.todo-list__label__description {
    position: absolute;
}

.ck-content .todo-list .todo-list__label>input[checked]:before {
    background: #23a6cd;
    border-color: #23a6cd;
}

.ck-content .todo-list .todo-list__label>input:before {
    display: block;
    position: absolute;
    box-sizing: border-box;
    content: "";
    width: 20px;
    height: 20px;
    border: 1px solid #333;
    border-radius: 100%;
    transition: box-shadow .25s ease-in-out,background .25s ease-in-out,border .25s ease-in-out;
}

.ck-content .todo-list .todo-list__label > input:after {
    left: 7px;
    top: 4px;
    width: 4px;
    height: 8px;
}
</style>
